import type { ReactNode } from 'react';

/**
 * Scroll pane for data tables — both-axis overflow, sticky headers,
 * and a stable `data-table-id` so column widths can persist per table.
 *
 * Always wrap list tables:
 * ```tsx
 * <TableScroll id="expenses">
 *   <table>…</table>
 * </TableScroll>
 * ```
 */
export function TableScroll({
  id,
  children,
  className,
}: {
  /** Stable id for localStorage column widths (e.g. "expenses", "invoices"). */
  id: string;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={['table-scroll', className].filter(Boolean).join(' ')}
      data-table-id={id}
    >
      {children}
    </div>
  );
}
